const CourseCompletionOrderEnum = {
  inOrder: 'IN_ORDER',
  anyOrder: 'ANY_ORDER'
};

export { CourseCompletionOrderEnum };
export default CourseCompletionOrderEnum;
